<ng-container *ngIf="relatedSpaceData$ | async as relatedSpaceData">
  <!-- HOST -->
  <app-related-user-row
    [label]="'Host' | translate"
    [users]="relatedSpaceData.hosts"
  ></app-related-user-row>

  <!-- PARTICIPANT -->
  <app-related-user-row
    [label]="'Participant' | translate"
    [users]="relatedSpaceData.participants"
  ></app-related-user-row>

  <!-- SPACE -->
  <app-related-link-row
    [label]="'Space' | translate"
    [iconConfig]="spaceIcon"
    [text]="relatedSpaceData.link.text"
    [url]="relatedSpaceData.link.url"
    dataName="alerts-related-space-link"
  ></app-related-link-row>
</ng-container>
